import { useDispatch } from 'react-redux'
import {
  changeEpisode,
  hidePlayer,
  pause as pauseEpisode,
  play as playEpisode,
  PlayerEpisodeInterface,
  setCurrentTime,
  setVolume as setVolumeEpisode,
  showPlayer,
  toggleMute as toggleMuteEpisode,
} from 'reducers/player'

const usePlayer = () => {
  const dispatch = useDispatch()

  const show = () => {
    dispatch(showPlayer())
  }

  const hide = () => {
    dispatch(hidePlayer({}))
  }

  const playNewAudio = (episode: PlayerEpisodeInterface) => {
    dispatch(changeEpisode(episode))
    show()
  }

  const play = () => {
    dispatch(playEpisode())
  }

  const pause = () => {
    dispatch(pauseEpisode())
  }

  const updateCurrentTime = (time: number) => {
    dispatch(setCurrentTime(time))
  }

  const setVolume = (volume: number) => {
    dispatch(setVolumeEpisode({ volume }))
  }

  const toggleMute = (isMuted?: boolean) => {
    dispatch(toggleMuteEpisode({ isMuted }))
  }

  return {
    show,
    play,
    pause,
    playNewAudio,
    updateCurrentTime,
    hide,
    setVolume,
    toggleMute,
  }
}

export default usePlayer
